module.exports = __webpack_public_path__ + "static/media/IMG-7.cf2cc3c0.jpg";